import styles from './GameDetailSpec.module.scss';

export type LabelType =
  | 'gamemode'
  | 'tema'
  | 'produttore'
  | 'jackpot'
  | 'volatility'
  | 'functionality'
  | 'lines'
  | 'start-date'
  | 'fee'
  | 'total-buyin'
  | 'game-type';

export type GameDetailSpecProps = {
  label: LabelType;
  values: string[] | null;
  id?: number;
};

export const GameDetailSpec = ({ label, values }: GameDetailSpecProps) => {
  const valuesFormattedString = values && (values.length > 1 ? values.join(', ') : values[0]);
  return (
    <li className={styles.container}>
      <h4 className={styles.label}>{label}</h4>
      <p className={styles.values}>{valuesFormattedString}</p>
    </li>
  );
};
